<template>
	<div>
		<div class="flex items-center">
		<input
			type="radio"
			class="cursor-pointer hover:border-gray-500"
			:id="inputId"
			:checked="isChecked"
			@change="onRadioChange"
			:value="radioValue"
			:name="name"
			:class="[
				'focus:ring-orange-500 h-5 w-5 text-orange-500',
				markInputInvalid ? 'border-red-600' : 'border-gray-300',
			]"
		/>

		<label
			:for="inputId"
			:class="[
				'flex items-center',
				isWhite
					? 'pl-3 block text-white-700 cursor-pointer'
					: 'pl-3 block text-gray-700 cursor-pointer',
			]"
		>
			<slot>{{ __(label) }}</slot>
			<ui-tooltip
				v-if="tooltipText"
				class="text-green-400 whitespace-normal"
				:icon-stroke-width="2"
				icon-class="ml-1 w-4 h-4"
				:text="__(tooltipText)"
			/>
		</label>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
		},
		form: {
			type: Object,
			required: false,
		},
		field: {
			type: String,
			required: false,
		},
		name: {
			required: true,
		},
		radioValue: {
			type: [String, Number], // todo prüfen
			required: true,
		},
		label: {
			type: String,
			required: false,
		},
		tooltipText: {
			type: String,
			default: "",
		},
		isWhite: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			validationErrors: null,
		};
	},
	computed: {
		inputId() {
			return "input-" + this._uid;
		},
		hasForm() {
			return this.form && this.field;
		},
		inValid() {
			return this.validationErrors?.length > 0;
		},
		markInvalid() {
			if (this.hasForm) {
				return this.form.hasErrors && this.form.errors[this.field] != null;
			}

			return false;
		},
		markInputInvalid() {
			return this.markInvalid || this.inValid;
		},
		isChecked() {
			// Wie v-model (looseEqual): Werte kommen teils als Zahl (0/1 aus DB/Filter), radioValue als String.
			return this.value != null && String(this.value) === String(this.radioValue);
		},
	},
	methods: {
		onRadioChange() {
			this.$emit("input", this.radioValue);
			this.$emit("change", this.radioValue);
		},
		setValidationErrors(errors) {
			this.validationErrors = this.field ? errors[this.field] : null;
		},
		validationEventListener() {
			if (this.hasForm) {
				let that = this;
				that.$bus.$emit("is-mark-invalid", that.field, that.markInvalid);
			}
		},
	},
	created() {
		this.$bus.$on("poll-is-mark-invalid", this.validationEventListener);
	},
	mounted() {
		this.$bus.$on("form:invalid", this.setValidationErrors);
	},
	beforeDestroy() {
		this.$bus.$off("poll-is-mark-invalid", this.validationEventListener);
		this.$bus.$off("form:invalid", this.setValidationErrors);
	},
};
</script>
